export const performance = {
  en: {
    bandsNote: "Scoring bands:",
    deleteTemplate: "Delete a template…",
    deleteTemplateTitle: "Delete this template?",
    deleteTemplateBody: "Cycles already using it keep their criteria. Only the template is removed.",
    deleteCycleTitle: "Delete this evaluation cycle?",
    deleteCycleBody: "This cannot be undone. Only draft cycles with no evaluations can be deleted.",
    title: "Performance",
    myPerformance: "My performance",
    disabled: "Performance management is not enabled.",
    enableModule: "Enable performance management",
    enableDescription: "While this is off the module does not appear for anyone and its API answers nothing.",
    employeeVisibility: "Let employees see their own completed evaluations",
    visibilityDescription: "Employees never see anyone else's evaluation, a ranking, or a manager's private note.",
    cycles: "Evaluation cycles",
    newCycle: "New cycle",
    cycleName: "Cycle name",
    period: "Period",
    periodStart: "From",
    periodEnd: "To",
    statusDraft: "Draft",
    statusActive: "Running",
    statusClosed: "Closed",
    startCycle: "Start cycle",
    closeCycle: "Close cycle",
    reopenCycle: "Reopen",
    deleteCycle: "Delete cycle",
    criteria: "Criteria",
    criterionName: "Criterion",
    criterionDescription: "Description",
    weight: "Weight",
    weightOptional: "Weight (optional)",
    addCriterion: "Add criterion",
    saveCriteria: "Save criteria",
    criteriaLocked: "The cycle is running, so its criteria can no longer change.",
    weightShare: "counts for {percent}%",
    weightsHint: "Weights are relative, not percentages. Leave them all empty to weight every criterion equally.",
    templates: "Templates",
    saveAsTemplate: "Save as template",
    useTemplate: "Use a template",
    reuseLast: "Reuse last cycle",
    templateName: "Template name",
    team: "Your team",
    evaluate: "Evaluate",
    continueEvaluation: "Continue",
    viewEvaluation: "View",
    notStarted: "Not started",
    scoredOf: "{scored} of {total} scored",
    score: "Score",
    comment: "Comment",
    summary: "Summary for the employee",
    privateNote: "Private note",
    privateNoteHint: "Only you can see this. It is never shown to the employee.",
    overallScore: "Overall score",
    submit: "Submit evaluation",
    reopen: "Reopen",
    submitted: "Submitted",
    acknowledged: "Acknowledged by the employee",
    acknowledge: "I have read this",
    acknowledgeHint: "Once you acknowledge it, it can no longer be changed.",
    noEvaluations: "No completed evaluations yet.",
    notShared: "Evaluations are not shared with employees in this organisation.",
    bandNeedsImprovement: "Needs improvement",
    bandDeveloping: "Developing",
    bandMeets: "Meets expectations",
    bandExceeds: "Exceeds expectations",
    bandOutstanding: "Outstanding",
    noPayrollEffect: "Performance scores never affect salary, bonuses or deductions.",
    history: "History",
  },
  ar: {
    bandsNote: "نطاقات التقييم:",
    deleteTemplate: "حذف قالب…",
    deleteTemplateTitle: "حذف هذا القالب؟",
    deleteTemplateBody: "تحتفظ الدورات التي تستخدمه بمعاييرها. يُحذف القالب فقط.",
    deleteCycleTitle: "حذف دورة التقييم؟",
    deleteCycleBody: "لا يمكن التراجع عن هذا الإجراء. يمكن حذف الدورات المسودة التي لا تحتوي على تقييمات فقط.",
    title: "الأداء",
    myPerformance: "أدائي",
    disabled: "إدارة الأداء غير مفعّلة.",
    enableModule: "تفعيل إدارة الأداء",
    enableDescription: "عند الإيقاف لا تظهر الوحدة لأي مستخدم ولا تستجيب واجهتها البرمجية.",
    employeeVisibility: "السماح للموظفين بالاطلاع على تقييماتهم المكتملة",
    visibilityDescription: "لا يرى الموظف تقييم غيره ولا أي ترتيب ولا ملاحظات المدير الخاصة.",
    cycles: "دورات التقييم",
    newCycle: "دورة جديدة",
    cycleName: "اسم الدورة",
    period: "الفترة",
    periodStart: "من",
    periodEnd: "إلى",
    statusDraft: "مسودة",
    statusActive: "جارية",
    statusClosed: "مغلقة",
    startCycle: "بدء الدورة",
    closeCycle: "إغلاق الدورة",
    reopenCycle: "إعادة الفتح",
    deleteCycle: "حذف الدورة",
    criteria: "المعايير",
    criterionName: "المعيار",
    criterionDescription: "الوصف",
    weight: "الوزن",
    weightOptional: "الوزن (اختياري)",
    addCriterion: "إضافة معيار",
    saveCriteria: "حفظ المعايير",
    criteriaLocked: "الدورة جارية، ولا يمكن تعديل معاييرها.",
    weightShare: "يمثل {percent}%",
    weightsHint: "الأوزان نسبية وليست نسباً مئوية. اتركها فارغة ليتساوى وزن جميع المعايير.",
    templates: "القوالب",
    saveAsTemplate: "حفظ كقالب",
    useTemplate: "استخدام قالب",
    reuseLast: "إعادة استخدام الدورة السابقة",
    templateName: "اسم القالب",
    team: "فريقك",
    evaluate: "تقييم",
    continueEvaluation: "متابعة",
    viewEvaluation: "عرض",
    notStarted: "لم يبدأ",
    scoredOf: "تم تقييم {scored} من {total}",
    score: "الدرجة",
    comment: "ملاحظة",
    summary: "الملخص الموجّه للموظف",
    privateNote: "ملاحظة خاصة",
    privateNoteHint: "تظهر لك فقط ولا تُعرض على الموظف أبداً.",
    overallScore: "الدرجة الإجمالية",
    submit: "اعتماد التقييم",
    reopen: "إعادة الفتح",
    submitted: "معتمد",
    acknowledged: "تم إقرار الموظف",
    acknowledge: "لقد اطلعت على التقييم",
    acknowledgeHint: "بعد الإقرار لا يمكن تعديل التقييم.",
    noEvaluations: "لا توجد تقييمات مكتملة بعد.",
    notShared: "لا تتم مشاركة التقييمات مع الموظفين في هذه المنشأة.",
    bandNeedsImprovement: "يحتاج إلى تحسين",
    bandDeveloping: "قيد التطور",
    bandMeets: "يلبي التوقعات",
    bandExceeds: "يفوق التوقعات",
    bandOutstanding: "متميز",
    noPayrollEffect: "درجات الأداء لا تؤثر على الراتب أو المكافآت أو الاستقطاعات.",
    history: "السجل",
  },
} as const;
